import axios from 'axios';
import store from '../../store';

const model = () => {
	return {
		label: 	'',
	};
};

const save = async (model) => {
	try {
		return model.id ? await axios.put(`/organisations/${model.id}`, model) : await axios.post(`/organisations`, model);
	} catch (err) {
		return false;
	}
};

const read = async(id) => {
	return (await axios.get(`/organisations/${id}`)).data;
};

const window = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'organisation-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const open = async (id, onSave) => {
	window(id ? await read(id) : model(), async (model) => {
		const r = await save(model);

		if (r) {
			if (onSave) onSave(r);
			return true;
		}

		return false;
	});
};

const del = async (id) => {
	await axios.delete(`/organisations/${id}`);
};

const openMigration = async () => {
	store.dispatch('win/push', {
		component: 	'organisation-migration-window-view',
		async submit(model) {
			return await submit(model);
		}
	});
};

export default {
	model,
	save,
	read,
	open,
	window,
	del,
	openMigration,
};
